import gallery5Img from "../assets/images/gallery-images/Impact_story_photo_e-SAATHI.jpg";
import gallery3Img from "../assets/images/gallery-images/story-gallery-img3.jpg";
import S3CLink from "../components/S3CLink";

const galleryList = [
  {
    id: 0,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: Woman learning how to use Nivi Chatbot</span> 
        <strong className='gallery-coalition-title'>The Phone Friend </strong>
        A woman who used e-SAATHI services shared that she received reliable information on pregnancy, nutrition, mental well-being and newborn care that prepared her for birth, reduced anxiety and helped her make informed decisions. The platform also supported her husband by fostering a shared sense of responsibility and emotional preparedness. She valued the guidance on breastfeeding, postpartum depression. The services facilitated a community of informed parents and reduced misinformation – which in turn supported women and their families navigate pregnancy and parenthood.
      </p>
    ),
    image: gallery5Img
  },
  {
    id: 1,
    caption: (
        <p>
        <span className='gallery-caption'>Photo: Women using Nivi chatbot</span> 
        <strong className='gallery-coalition-title'>A Click Away from Pregnancy Advice</strong>
        Mothers feel that the Nivi chatbot offers comprehensive guidance throughout the pregnancy journey from conception to postpartum care. The mothers noted that “in the presence of multiple conflicting sources of information, the chatbot provides official advice that is empowering." The chatbot's tailored advice and recommendations on dietary matters has also proven valuable in preparing for pregnancy. They also appreciated the timely notification for what to expect in the coming week.
      </p>
    ),
    image: gallery3Img
  }
];

export default galleryList;
